import { Outlet } from 'react-router-dom';
import { BottomBarProvider } from '@contexts/BottomBarContext';

export const AuthentifiedLightLayout = () => {
    return (
        <BottomBarProvider>
            <div className="authentified-light-layout">
                <Outlet />
            </div>
        </BottomBarProvider>
    );
};

export default AuthentifiedLightLayout;
